import config from "@/config";
import store from "@/store";
import { Http } from '@capacitor-community/http';

let capHTTP = {
  defaults: {
    baseURL: config.api.url,
    headers: {
      common: {
        "content-type": "application/json;charset=UTF-8",
        "x-api-key": config.api.key,
      },
    },
  },
  get: async function(path, params) {
    return await request("GET", path, params);
  },
  post: async function(path, body) {
    return await request("POST",  path, null, body);
  },
  request: async function(options, method) {
    return await Http.request({ ...options, method: method });
  },
  put: async function(path, body) {
    return await request("PUT", path, null, body);
  },
  delete: async function(path, body) {
    return await request("DELETE", path, null, body);
  },
  upload: async function(url, name, blob, path){
    const options = {
      url,
      name: name,
      filePath: path,
      blob 
      //fileDirectory: FilesystemDirectory.Downloads,
    };

    return await Http.uploadFile();
  }
};

async function request(method, path,params,body){
  let api = config.api
  //if (store.state.user && store.state.user.test) api = config.testapi
  //process.env.NODE_ENV == 'development' || 
  if (store.state.modus == 'test') api = config.testapi
  const options = {
    url: api.url + path,
    headers: {
      'Accept': 'application/json',
      "content-type": "application/json;charset=UTF-8",
      "x-api-key": api.key,
      "Authorization" : store.getters.token
    },
    params: params,
    data: body,
  };
  return await Http.request({ ...options, method: method});
}
async function requestFetch(method, path,params,body){
  let api = config.api
  //if (store.state.user && store.state.user.test) api = config.testapi
  //process.env.NODE_ENV == 'development' || 
  if (store.state.modus == 'test') api = config.testapi
  if(params) {
    path += (path.indexOf('?') === -1 ? '?' : '&') + queryParams(params);
  }
    try{
      let response = await fetch(
        api.url + path, {
          method: method,
          headers: {
            'Accept': 'application/json',
            "content-type": "application/json;charset=UTF-8",
            "x-api-key": api.key,
            "Authorization" : store.getters.token
          },
          body: JSON.stringify(body)
      });
      let responseText = await response.json();
      //if (response.status >= 200 && response.status < 300){
      return {data: responseText}
      //}
      
    } catch(e) {
      

      return {status: 'ERROR', 'message': e.message}
    }
}

export default capHTTP;



function queryParams(params) {
    return Object.keys(params)
        .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
        .join('&');
}